import { USERS_ADMIN_FILTER,CLEAR_USERS_ADMIN_FILTER } from "../types"

const initialState = {
    usersAdminFilter: [],
}

const usersAdminFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case USERS_ADMIN_FILTER:
            return {
                ...state,
                usersAdminFilter: action.payload,
            }
        case CLEAR_USERS_ADMIN_FILTER:
            return {
                ...state,
                usersAdminFilter: [],
            }
        default:
            return state
    }
}

export default usersAdminFilterReducer
